import axiosInstance from '../utils/axiosConfig';

export interface Setting {
  key: string;
  category: string;
  name: string;
  description?: string;
  value: any;
  data_type: string;
  is_required: boolean;
  is_sensitive: boolean;
}

export interface SettingCreate {
  key: string;
  category: string;
  name: string;
  description?: string;
  value: any;
  data_type: string;
  is_required?: boolean;
  is_sensitive?: boolean;
}

export interface SettingUpdate {
  category?: string;
  name?: string;
  description?: string;
  value?: any;
  data_type?: string;
  is_required?: boolean;
  is_sensitive?: boolean;
}

export const listSettings = async (category?: string): Promise<Setting[]> => {
  const params = new URLSearchParams();
  if (category) params.append('category', category);
  
  const { data } = await axiosInstance.get<Setting[]>(`/api/v1/settings?${params.toString()}`);
  return data;
};

export const getCategories = async (): Promise<string[]> => {
  const { data } = await axiosInstance.get<string[]>('/api/v1/settings/categories');
  return data;
};

export const getSetting = async (key: string): Promise<Setting> => {
  const { data } = await axiosInstance.get<Setting>(`/api/v1/settings/${key}`);
  return data;
};

export const createSetting = async (setting: SettingCreate): Promise<Setting> => {
  const { data } = await axiosInstance.post<Setting>('/api/v1/settings', setting);
  return data;
};

export const updateSetting = async (key: string, setting: SettingUpdate): Promise<Setting> => {
  const { data } = await axiosInstance.put<Setting>(`/api/v1/settings/${key}`, setting);
  return data;
};

export const deleteSetting = async (key: string): Promise<void> => {
  await axiosInstance.delete(`/api/v1/settings/${key}`);
};

export const initializeDefaultSettings = async (): Promise<{ message: string; created: number; updated: number }> => {
  const { data } = await axiosInstance.post('/api/v1/settings/initialize');
  return data;
};

export const getWorkerDefaults = async (): Promise<any> => {
  const { data } = await axiosInstance.get('/api/v1/settings/business/worker-defaults');
  return data;
};

export const getStoreDefaults = async (): Promise<any> => {
  const { data } = await axiosInstance.get('/api/v1/settings/business/store-defaults');
  return data;
}; 